export enum UtilizationTag {
  A_B_TESTING = "a/b_testing",
  LANDSCAPED = "landscaped",
  TRACKED = "tracked"
}

export enum SimpleSourceTag {
  SQPR = "sqpr",
  MANUAL = "manual",
  SIGNAL_AI = "signal_ai",
  LANDSCAPE = "landscape",
  SUBCATEGORY_DISCOVERY = "subcategory_discovery"
}

export type SourceTag = SimpleSourceTag | LandscapeSourceTag;

export interface LandscapeSourceTag {
  type: "Landscape";
  landscapeName: string;
  landscapeId: number;
}

export type Keyword = {
  id: number;
  search: string;
  product_id: number;

  rank: number | null;
  search_volume: number | null;
  search_volume_trend: string | null;
  kps: number | null;
  landscape_key: string | null;

  created_at: string | null;
  updated_at: string | null;

  landscape_id: number | null;

  ppc: number | null;
  ppc_min_bid: number | null;
  ppc_max_bid: number | null;

  keyword_sales: number | null;
  asin_density: number | null;
  competitors: number | null;

  ranks: any | null;

  hero_relevance: number | null;
  // AUT-496. All six null together = never scored. found > 0 with scored = 0 and null percentages
  // = page 1 was found but none of it could be read, which the screen shows differently.
  serp_match_pct: number | null;
  serp_match_organic_pct: number | null;
  serp_match_sponsored_pct: number | null;
  serp_match_scored: number | null;
  serp_match_found: number | null;
  serp_match_week: string | null;

  includes_hero_brand: boolean;
  includes_competitor_brand: boolean;
  no_overlap_with_hero_content: boolean;

  kps_raw: number | null;
  kps_search_score: number | null;
  kps_search_trend_score: number | null;
  kps_hero_rank_score: number | null;
  hero_rank: number | null;
  kps_hero_relevance_score: number | null;
  kps_ppc_score: number | null;
  kps_asin_density_score: number | null;
  kps_keyword_sales_score: number | null;
  // AUT-200: optional so the SEO/keyword adapter + fixture objects (which omit
  // the kps_max_* family) still satisfy Keyword; real API rows always include it.
  kps_competition_score?: number | null;

  // keyword-source-migration (FR-8): optional so the SEO/keyword adapter
  // (SeoInsightsContentV2.tsx) and buildOptimisticKeyword, which construct a
  // Keyword literal without these, still satisfy the type; the hero-keywords
  // API always sends both.
  hero_rank_asin?: string | null;
  hero_rank_from_sibling?: boolean;

  kps_max_hero_relevance_score: number | null;
  kps_max_search_score: number | null;
  kps_max_asin_density_score: number | null;
  kps_max_hero_rank_score: number | null;
  kps_max_search_trend_score: number | null;
  kps_max_keyword_sales_score: number | null;
  kps_max_competition_score?: number | null;

  kps_hero_relevance_factor: number | null;
  hero_relevance_adjusted: number | null;

  rank_if_converted: number | null;

  individual_contribution: number | null;
  conversion: number | null;

  ranked_from_1_to_15: number | null;
  ranked_from_16_to_40: number | null;
  ranked_from_41_to_150: number | null;
  ranked_from_151: number | null;
  ranked_from_1: number | null;

  is_master_list?: boolean;

  landscape: { id: number; search_phrase: string } | null;

  utilizationTags?: UtilizationTag[];

  utilization?: string[];

  sources?: string[];
  sourceTags?: SimpleSourceTag[] | LandscapeSourceTag[];
};

export type CreateKeywordParams = {
  search: string;
  product_id: number;
  rank?: number | null;
  search_volume?: number | null;
  search_volume_trend?: string | null;
  kps?: number | null;
  landscape_url?: string | null;
};

export type UpdateKeywordParams = {
  search?: string;
  rank?: number | null;
  search_volume?: number | null;
  search_volume_trend?: string | null;
  kps?: number | null;
  landscape_url?: string | null;
};

export type GetKeywordsParams = {
  product_id?: number;
  per_page?: number;
};

export type AddHeroProductKeywordsParams = {
  productId: number;
  brandId: number;
  keywords: string[];
};
